import React from "react";
import { Section } from "../../../components/section";
import { SectionHeader } from "../../../components/section-header";
import { ParagraphGroup } from "../../../components/paragraph-group";
import { Video } from "../../../components/video";

export interface IOverviewProps {
    sectionId: string;
    index: number;
}

export function Overview(props: IOverviewProps) {
    const formattedIndex = props.index > 10 ? props.index : `0${props.index}`;
    return (
        <Section
            sectionId={props.sectionId}
            isLast={false}
        >
            <SectionHeader
                title={`${formattedIndex} Overview`}
            />
            <Video
                videoSrc="https://www.youtube.com/embed/CQXKH8Y8o48"
            />
            <ParagraphGroup
                title="project brief"
                body={[
                    "This year, our team partnered with the Pacific Northwest National Laboratory (PNNL) to explore one of the most complex and pervasive issues of our time—misinformation on social platforms.",
                    "While the vast majority of platform users are concerned about the credibility of their engagement, they still unintentionally consume and spread misinformation. To address this, we created a human-AI collaborative system to foster new norms for platform design and user behavior to mitigate the spread of misinformation."
                ]}
            />
        </Section>
    );
}
